/**
 * Подключаем Vue библиотеки
 */
// App.vue.setComponent(require('vue3-perfect-scrollbar').PerfectScrollbar); // name PerfectScrollbar


App.vue.setComponent(require('./components/TopPageBanner.vue').default)
App.vue.setComponent(require('./components/main/AppHeader.vue').default)
App.vue.setComponent(require('./components/main/PageInfo.vue').default)
App.vue.setComponent(require('./components/PageHero.vue').default)
App.vue.setComponent(require('./components/PageHeader.vue').default)
App.vue.setComponent(require('./components/AppSection.vue').default)
App.vue.setComponent(require('./components/Hero.vue').default)
App.vue.setComponent(require('./components/sections/TwoColsSection.vue').default)
App.vue.setComponent(require('./components/sections/NumbersSection.vue').default);
App.vue.setComponent(require('./components/sections/TasksSection.vue').default)
App.vue.setComponent(require('./components/sections/HelpSection.vue').default);
App.vue.setComponent(require('./components/sections/CategoriesSection.vue').default);
App.vue.setComponent(require('./components/sections/ReviewsSliderSection.vue').default);
App.vue.setComponent(require('./components/sections/TopVolontersSection.vue').default);
App.vue.setComponent(require('./components/sections/VolunteerPageInformBlock.vue').default);
App.vue.setComponent(require('./components/sections/ArticlesSection.vue').default);
App.vue.setComponent(require('./components/sections/PartnersSliderSection.vue').default);
App.vue.setComponent(require('./components/sections/PopularDirectionsSection.vue').default);
App.vue.setComponent(require('./components/sections/ClientsSection.vue').default);
App.vue.setComponent(require('./components/sections/Subscribe.vue').default);
App.vue.setComponent(require('./components/sections/faq.vue').default);
App.vue.setComponent(require('./components/main/AppFooter.vue').default)
App.vue.setComponent(require('./components/popups/CookiePopup.vue').default);
App.vue.setComponent(require('./components/popups/MessagePopUp.vue').default);
App.vue.setComponent(require('./components/ScrollToTop.vue').default)
App.vue.setComponent(require('./components/popups/RegisterPopup.vue').default)
App.vue.setComponent(require('./components/main/ProgressBar.vue').default)
App.vue.setComponent(require('./components/sections/SuccessSection.vue').default)
App.vue.setComponent(require('./components/sections/PromotionSection.vue').default)
App.vue.setComponent(require('./components/404.vue').default)

App.vue.setComponent(require('./components/top-active-volunteers/TopActiveVolunteersPage.vue').default);
App.vue.setComponent(require('./components/top-active-volunteers/TopActiveVolunteersList.vue').default);
App.vue.setComponent(require('./components/top-active-volunteers/TopActiveVolunteersCard.vue').default);

App.vue.setComponent(require('./components/forms/RegisterNPO.vue').default)
App.vue.setComponent(require('./components/forms/TaskFilter.vue').default);
App.vue.setComponent(require('./containers/NKOPageContainer.vue').default)
App.vue.setComponent(require('./containers/request/RequestPageContainer.vue').default)
App.vue.setComponent(require('./containers/request/RequestCreatePageContainer.vue').default)
App.vue.setComponent(require('./containers/request/RequestListPageContainer.vue').default)
App.vue.setComponent(require('./containers/volunteer/VolunteersListPageContainer.vue').default)
App.vue.setComponent(require('./components/cards/InfoCard.vue').default)
App.vue.setComponent(require('./containers/volunteer/VolunteerDetailPageContainer.vue').default)
App.vue.setComponent(require('./containers/volunteer/VolunteersRatingPageContainer.vue').default)
App.vue.setComponent(require('./containers/ChatPageContainer.vue').default);
App.vue.setComponent(require('./components/chat/NewMessageIdent.vue').default);
App.vue.setComponent(require('./components/chat/simpleMessagePopUp.vue').default);

App.vue.setComponent(require('./components/forms/RegistrationVolonter.vue').default);
App.vue.setComponent(require('./containers/UI.vue').default)
App.vue.setComponent(require('./containers/AuthPageContainer.vue').default)
App.vue.setComponent(require('./containers/ContactsPageContainer.vue').default)
App.vue.setComponent(require('./components/Map.vue').default)
App.vue.setComponent(require('./containers/ReviewsPageContainer.vue').default)
App.vue.setComponent(require('./containers/SurveyPageContainer.vue').default)
App.vue.setComponent(require('./containers/DirectionPageContainer.vue').default)
App.vue.setComponent(require('./containers/AboutPageContainer.vue').default)
App.vue.setComponent(require('./containers/BlogContainer.vue').default)
App.vue.setComponent(require('./components/forms/auth/SystemFormAuth.vue').default)

App.vue.setComponent(require('./components/sections/OthersSpecialists.vue').default);
App.vue.setComponent(require('./components/sections/IconCardsSection.vue').default);
App.vue.setComponent(require('./components/sections/volonter.vue').default);
App.vue.setComponent(require('./components/sections/AccountNKO.vue').default);
App.vue.setComponent(require('./components/sections/AccountProjects.vue').default);
App.vue.setComponent(require('./components/sections/AccountChat.vue').default);
App.vue.setComponent(require('./components/cards/AboutPages.vue').default);

App.vue.setComponent(require('./components/main/TabMenu.vue').default);
App.vue.setComponent(require('./components/sections/TeamSection.vue').default);
App.vue.setComponent(require('./components/popups/RespondApplication/RespondApplication.vue').default);
App.vue.setComponent(require('./components/popups/RespondApplication/RespondApplicationFile.vue').default);
App.vue.setComponent(require('./components/popups/RespondApplication/RespondComplete.vue').default);
App.vue.setComponent(require('./components/popups/RespondApplication/ResponseCheckComplete.vue').default);
App.vue.setComponent(require('./components/popups/TaskOnModeration.vue').default);
App.vue.setComponent(require('./components/user-html-area.vue').default);

/** OurTeam **/
App.vue.setComponent(require('./components/OurTeam/OurTeam.vue').default);
App.vue.setComponent(require('./components/OurTeam/OurTeamCard.vue').default);
App.vue.setComponent(require('./components/OurTeam/OurTeamMember.vue').default);
App.vue.setComponent(require('./components/OurTeam/OurTeamBanner.vue').default);

/** Partners **/
App.vue.setComponent(require('./components/Partners/PartnersList/PartnersList.vue').default);
App.vue.setComponent(require('./components/Partners/PartnersList/PartnersListItem.vue').default);
App.vue.setComponent(require('./components/Partners/PartnersAdvantages/PartnersAdvantages.vue').default);
App.vue.setComponent(require('./components/Partners/PartnersSlider/PartnersSlider.vue').default);

/** HelpBlock **/
App.vue.setComponent(require('./components/HelpBlock/HelpBlock.vue').default);
App.vue.setComponent(require('./components/HelpBlock/HelpBlockItem.vue').default);

/** About us **/
App.vue.setComponent(require('./components/AboutUs/AboutUsSlider/AboutUsSlider.vue').default);
App.vue.setComponent(require('./components/AboutUs/AboutUsSlider/AboutUsSliderItem.vue').default);

/** Reviews **/
App.vue.setComponent(require('./components/Reviews/Reviews/Reviews.vue').default);
App.vue.setComponent(require('./components/Reviews/Reviews/ReviewsItem/ReviewsItem.vue').default);
App.vue.setComponent(require('./components/Reviews/Reviews/ReviewsItem/ReviewsItemAnswer.vue').default);

/** Reviews page **/
App.vue.setComponent(require('./components/Reviews/ReviewsPage/ReviewsPage.vue').default);
App.vue.setComponent(require('./components/Reviews/ReviewsPage/ReviewsPageItem.vue').default);
App.vue.setComponent(require('./components/Reviews/Reviews/ReviewsModal.vue').default);
App.vue.setComponent(require('./components/Reviews/ReviewsPage/ReviewsPageMobile/ReviewsPageMobile.vue').default);
App.vue.setComponent(require('./components/Reviews/ReviewsPage/ReviewsPageBanner/ReviewsPageBanner.vue').default);
App.vue.setComponent(require('./components/Reviews/ReviewsPage/ReviewsPageModal/ReviewsPageModal.vue').default);
/** Partner **/
App.vue.setComponent(require('./components/Partner/PartnerJoin/PartnerJoin.vue').default);
App.vue.setComponent(require('./components/Partner/PartnerJoin/PartnerJoinCard.vue').default);
App.vue.setComponent(require('./components/Partner/PartnerRegistration/PartnerRegistration.vue').default);
App.vue.setComponent(require('./components/Partner/PartnerList/PartnerList.vue').default);
App.vue.setComponent(require('./components/Partner/PartnerBanner/PartnerBanner.vue').default);
App.vue.setComponent(require('./components/UsefulInformation/UsefulInformation.vue').default);
App.vue.setComponent(require('./components/UsefulInformation/UsefulInformationCard.vue').default);
App.vue.setComponent(require('./components/Partner/InviteLink/InviteLink.vue').default);

/** Achievements **/
App.vue.setComponent(require('./components/Achievements/Achievements.vue').default);
App.vue.setComponent(require('./components/Achievements/AchievementsItem.vue').default);
App.vue.setComponent(require('./components/Achievements/AchievementsBanner.vue').default);

/** Blog **/
App.vue.setComponent(require('./components/Blog/Publication/Publication.vue').default);
App.vue.setComponent(require('./components/Blog/Publication/PublicationInform.vue').default);
App.vue.setComponent(require('./components/Blog/Publication/PublicationPictureSlider.vue').default);
App.vue.setComponent(require('./components/Blog/Publication/PublicationMember/PublicationMemberSlider.vue').default);
App.vue.setComponent(require('./components/Blog/Publication/PublicationMember/PublicationMemberItem.vue').default);
App.vue.setComponent(require('./components/Blog/Publication/PublicationSubscription/PublicationSubscription.vue').default);
App.vue.setComponent(require('./components/Blog/Publication/PublicationAuthor.vue').default);

/** Search **/
App.vue.setComponent(require('./components/Search/SearchForm.vue').default)
App.vue.setComponent(require('./components/Search/SearchEngineTop/SearchEngineTopResponse.vue').default);
App.vue.setComponent(require('./components/Search/SearchElement.vue').default);

/** NKO detail **/
App.vue.setComponent(require('./components/NkoDetail/NkoDetail.vue').default);
App.vue.setComponent(require('./components/NkoDetail/NkoDetailHeader.vue').default);
App.vue.setComponent(require('./components/NkoDetail/NkoCompany.vue').default);
App.vue.setComponent(require('./components/NkoDetail/NkoDetailMenu.vue').default);
App.vue.setComponent(require('./components/NkoDetail/NkoDetailContent.vue').default);
App.vue.setComponent(require('./components/NkoDetail/NkoDetailProjects/NkoDetailProjects.vue').default);
App.vue.setComponent(require('./components/NkoDetail/NkoDetailProjects/NkoDetailProjectsItem.vue').default);

/** About **/
App.vue.setComponent(require('./components/sections/StoriesSliderSection.vue').default);
App.vue.setComponent(require('./components/sections/BannerSection.vue').default);
